import { ClipboardDocumentCheckIcon } from '@heroicons/react/24/outline';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { toast } from 'react-toastify';

const CopyOnCipboardArea = ({ text, onCopyText, key = null }) => {
  const notify = () => {
    toast.info('Copied to Clipboard!', {
      autoClose: 1000,
    });
  };
  return (
    <div
      key={key}
      className="bg-blue-100 text-blue-700 rounded-lg border-[1px] border-blue-700 py-3 pb-5 relative"
    >
      <CopyToClipboard text={onCopyText || text}>
        <ClipboardDocumentCheckIcon
          onClick={notify}
          className="cursor-pointer w-7 h-7 border-[1px] border-blue-700 rounded-md text-blue-700 absolute right-2 top-2 p-1 hover:border-blue-900 hover:text-blue-900"
        />
      </CopyToClipboard>

      <pre>{text}</pre>
    </div>
  );
};

export default CopyOnCipboardArea;
